import { render, staticRenderFns } from "./CustorAnaly_C.vue?vue&type=template&id=589ff7ca&scoped=true&"
import script from "./CustorAnaly_C.vue?vue&type=script&lang=js&"
export * from "./CustorAnaly_C.vue?vue&type=script&lang=js&"
import style0 from "./CustorAnaly_C.vue?vue&type=style&index=0&id=589ff7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ff7ca",
  null
  
)

export default component.exports